/**
 * Shared validation instances
 * --
 * These are all pure functions which can be passed to an input's `rules` attribute
 * for validation. If this starts to become unmanageable it may be worth adopting
 * a more robust solution such as VeeValidate or vuelidate.
 */
export const required = val => !!val || 'Required'

const CURRENCY_REGEXP = /^[$]*(\d{1,3})(,*\d{1,3})*(\.\d+)?$/
export const currency = val => CURRENCY_REGEXP.test(val) || 'Amount is invalid'

const EMAIL_REGEXP = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/
export const email = val => EMAIL_REGEXP.test(val) || 'E-mail address is invalid'

export const phone = val => (val && val.length === 10) || 'Phone must be a valid US number'

const ZIP_REGEXP = /^\d{5}(-\d{4})?$/
export const zip = val => ZIP_REGEXP.test(val) || 'ZIP code is invalid'
